// Web Push helpers for admin PWA. Only loaded when admin app mounts.
import { api } from "./api";

function fromBase64Url(value) {
  const pad = "=".repeat((4 - (value.length % 4)) % 4);
  const binary = atob(value.replace(/-/g, "+").replace(/_/g, "/") + pad);
  return Uint8Array.from(binary, (c) => c.charCodeAt(0));
}

export const pushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export const notificationStatus = () =>
  typeof Notification !== "undefined" ? Notification.permission : "unsupported";

/** Register the service worker scoped to /admin/. Safe to call multiple times. */
export async function registerAdminSW() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const existing = await navigator.serviceWorker.getRegistration("/admin/");
    if (existing) return existing;
    return await navigator.serviceWorker.register("/admin-sw.js", { scope: "/admin/" });
  } catch (e) {
    console.warn("SW register failed", e);
    return null;
  }
}

/** Returns current PushSubscription or null. */
export async function getCurrentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/admin/");
  if (!reg) return null;
  try { return await reg.pushManager.getSubscription(); }
  catch { return null; }
}

/** Prompts for permission + subscribes + stores on backend. */
export async function enablePush() {
  if (!pushSupported()) throw new Error("Bu tarayıcı push bildirimlerini desteklemiyor.");
  if (Notification.permission === "denied")
    throw new Error("Bildirim izni engellenmiş. Tarayıcı ayarlarından açmanız gerek.");
  const reg = (await registerAdminSW()) || (await navigator.serviceWorker.ready);
  if (!reg) throw new Error("Service worker kaydedilemedi.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Bildirim izni verilmedi.");
  const { data } = await api.get("/public/push/vapid-public-key");
  if (!data?.publicKey) throw new Error("Sunucudan VAPID anahtarı alınamadı.");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: fromBase64Url(data.publicKey),
    });
  }
  const payload = sub.toJSON();
  await api.post("/admin/push/subscribe", {
    endpoint: payload.endpoint,
    keys: payload.keys,
    label: navigator.userAgent.slice(0, 80),
  });
  return sub;
}

export async function disablePush() {
  const sub = await getCurrentSubscription();
  if (sub) {
    try { await api.post("/admin/push/unsubscribe", { endpoint: sub.endpoint }); } catch {}
    try { await sub.unsubscribe(); } catch {}
  }
}

export async function sendTestPush() {
  await api.post("/admin/push/test", {
    title: "Test bildirimi ✨",
    body: "Mobil push çalışıyor, hazırsınız!",
    url: "/admin",
  });
}
